import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import TagsListApiRequest from "../request/TagsListApiRequest";
import Tag from "../model/Tag";
import { isHiddenTag } from "../../utils/hiddenTags";

const TagsListApiService = async (
  request: TagsListApiRequest
): Promise<Tag[]> => {
  const url = "/employertag/";
  const { data } = await axios.get(url, {
    params: request,
  });

  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useTagsListApiService = (request: TagsListApiRequest) =>
  useQuery<Tag[], AxiosError>(
    ["TagsListApiService", ...Object.values(request)],
    () => TagsListApiService(request),
    {
      keepPreviousData: true,
      select: (tags) =>
        tags.filter((tag) => !isHiddenTag(tag)),
    },
  );
export default useTagsListApiService;
